module.exports = __webpack_public_path__ + "assets/img/moveIcon.bef9a430.svg";